
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnusrb-si-mock-test",
      function () {
        return require("private-next-pages/tnusrb-si-mock-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnusrb-si-mock-test"])
      });
    }
  